import React, { useCallback } from 'react';
import * as Yup from 'yup';

import FmcForm from 'components/FmcForm';
import FormPrescreenIdView from './FormPrescreenIdView';
import useQueryParameters from 'hooks/useQueryParameters';

import { isPrescreenId } from 'utils/validations';

const schema = Yup.object().shape({
  prescreenId: Yup.string()
    .required('Required')
    .concat(isPrescreenId),
});

export type FormValues = ReturnType<typeof schema.cast>;

interface PropTypes {
  virtualLookupCall: (id: string) => Promise<void>;
  attempts: number;
  maxAttempts: number;
}

const FormPrescreenId: React.FC<PropTypes> = props => {
  const { virtualLookupCall, attempts, maxAttempts } = props;
  const { prescreenId } = useQueryParameters();

  const onSubmit = useCallback(
    async (values: FormValues) => {
      virtualLookupCall(values.prescreenId);
    },
    [virtualLookupCall],
  );

  const initialValues: FormValues = {
    prescreenId: prescreenId || '',
  };

  return (
    <FmcForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={schema}
      initialTouched={{
        prescreenId: Boolean(prescreenId),
      }}
    >
      {props => (
        <FormPrescreenIdView
          {...props}
          attempts={attempts}
          maxAttempts={maxAttempts}
        />
      )}
    </FmcForm>
  );
};

export default FormPrescreenId;
